import Heading from "../../components/heading";
import background from "../../images/blue_background.jpg"
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import BenchmarkChart from '../../components/BenchmarkChart.jsx'
import MetricsTable from '../../components/MetricsTable.jsx'
import { MOCK_SCORES } from '../../data.js'
import "./Comparison.css"
import { comparison } from "../../components/navbar.js";

const ATTACK_OPTIONS = ['Malware','Brute Force','DDoS']

export default function Comparison(){
  const [params, setParams] = useSearchParams()
  const selected = params.get('attack') && ATTACK_OPTIONS.includes(params.get('attack'))
    ? params.get('attack')
    : 'Malware'

  const scores = MOCK_SCORES[selected]

  const rows = useMemo(()=>{
    // Derive example metrics to align with composite score; replace with real data later
    return [
      { alg:'AES',       speed: Math.round(scores.AES*0.4), robust: Math.round(scores.AES*0.4), resource: Math.round(100 - scores.AES*0.2), composite: scores.AES },
      { alg:'RSA',       speed: Math.round(scores.RSA*0.35), robust: Math.round(scores.RSA*0.45), resource: Math.round(100 - scores.RSA*0.2), composite: scores.RSA },
      { alg:'Colorantí', speed: Math.round(scores.Coloranti*0.45), robust: Math.round(scores.Coloranti*0.4), resource: Math.round(100 - scores.Coloranti*0.15), composite: scores.Coloranti }
    ]
  }, [selected])

  const onSelect = (e) => {
    setParams({ attack: e.target.value })
  }

  return (
    <>
    <Heading />
    
      <main className="comp_container">
        <img src={background} alt="city scape" className="bg-image"></img>      

        <section className="panel">
        <header className="site-header">
          <h1>Encryption Benchmark Testing</h1>
          <p className="tagline">Colorantí VS Industry Titans</p>
        </header>        
          <label htmlFor="attackSelect"><strong>Select attack scenario</strong></label>{' '}
          <select id="attackSelect" value={selected} onChange={onSelect}>
            {ATTACK_OPTIONS.map(a => <option key={a} value={a}>{a}</option>)}
          </select>        
          <h2>Graph: Composite Scores</h2>
          <BenchmarkChart attack={selected} scores={scores} />
          <p className="tagline">Composite score per algorithm — larger bar = better ({selected})</p>
        </section>

        <section className="panel">
          <h3>Metrics table (mock data)</h3>
          <MetricsTable rows={rows} />
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button className="btn secondary" onClick={comparison}>Vector Attacks</button>
          </div>        
        </section>

        <footer className="demo-footer">
          <small>DEMONSTRATION ONLY</small>
        </footer>
      </main>
    
    </>
  )
}
